import React from "react";
import { Card, CardBody, CardHeader } from "reactstrap";

interface Props {
    title: string;
    /** Right side of the title row (e.g. a refresh button). */
    headerExtra?: React.ReactNode;
    /** Search, folders, status filters: the dashed row under the title. */
    filters?: React.ReactNode;
    children: React.ReactNode;
}

/** A list page's card, laid out like the app's other lists (see Content/QuickAnswer/index). */
const ListCard = ({ title, headerExtra, filters, children }: Props) => (
    <Card>
        <CardHeader className="border-bottom-0 d-flex align-items-center gap-2">
            <h5 className="card-title mb-0 flex-grow-1">{title}</h5>
            {headerExtra}
        </CardHeader>
        {filters &&
            <CardBody className="border border-dashed border-end-0 border-start-0 pb-3">{filters}</CardBody>}
        <CardBody>{children}</CardBody>
    </Card>
);

export default ListCard;
